import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

interface HeaderProps {
  logo?: string;
  title?: string;
  navigation?: Array<{
    label: string;
    href: string;
  }>;
}

const Header: React.FC<HeaderProps> = ({ logo, title, navigation }) => {
  return (
    <header className="app-header">
      <div className="header-content">
        {logo && (
          <img src={logo} alt="Logo" className="header-logo" />
        )}
        {title && (
          <h1 className="header-title">{title}</h1>
        )}
        {navigation && (
          <nav className="header-nav">
            {navigation.map((item, index) => (
              <Link key={index} to={item.href} className="nav-link">
                {item.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;